module.exports = __webpack_public_path__ + "img/mamalous_logo.73b9cbe9.png";